__turbopack_context__.v({
  "animatedLike": "uy-Lyq_animatedLike",
  "emptyLikeIcon": "uy-Lyq_emptyLikeIcon",
  "filledLikeIcon": "uy-Lyq_filledLikeIcon",
  "likeCount": "uy-Lyq_likeCount",
  "likeHeartbeat": "uy-Lyq_likeHeartbeat",
  "likeIcon": "uy-Lyq_likeIcon",
  "whiteLikeButton": "uy-Lyq_whiteLikeButton",
});
